import styles from './Resources.module.css';

export const ProyectosFinales: React.FC = () => {
  const proyectos = [
    {
      id: 1,
      titulo: 'Proyecto 1: Diseño de Programa de Mejoramiento',
      descripcion:
        'Desarrollar un programa completo de mejoramiento para un cultivo de interés regional. Debe incluir: objetivos específicos y cuantificables, identificación y caracterización de fuentes de germoplasma, método de mejoramiento justificado según sistema reproductivo, cronograma detallado (8-12 años), recursos humanos y materiales necesarios, estrategia de evaluación multiambiental, y plan de multiplicación de semilla.',
      ejemplo: 'Programa de mejoramiento de maní para resistencia a Sclerotinia en zona Córdoba.',
    },
    {
      id: 2,
      titulo: 'Proyecto 2: Análisis de Cultivar Comercial Argentino',
      descripcion:
        'Investigar la historia de desarrollo de un cultivar argentino exitoso. Debe cubrir: genealogía completa (parentales, método de mejoramiento), características agronómicas distintivas, impacto económico y adopción por zona, ventajas comparativas vs. cultivares previos, y perspectivas futuras de mercado.',
      ejemplo:
        'Ejemplos sugeridos: Trigo Buck Poncho, Maíz ACA 2000, Soja Don Mario 4800, Girasol DK4050.',
    },
    {
      id: 3,
      titulo: 'Proyecto 3: Evaluación de Impacto de Biotecnología',
      descripcion:
        'Análisis crítico y multidimensional del impacto de eventos transgénicos en agricultura argentina. Cubrir: aspectos agronómicos (rendimiento, manejo de malezas/plagas), económicos (costos, rentabilidad, mercados), ambientales (uso de agroquímicos, biodiversidad, resistencia), sociales (concentración, pequeños productores), y regulatorios (marco legal argentino, CONABIA).',
      ejemplo:
        'Casos de estudio: Soja RR (glifosato), Maíz Bt (Cry1Ab), Algodón Bt+RR (eventos apilados).',
    },
    {
      id: 4,
      titulo: 'Proyecto 4: Mejoramiento Participativo con Agricultores',
      descripcion:
        'Propuesta de programa de mejoramiento participativo (PPB - Participatory Plant Breeding) con pequeños productores. Incluir: identificación de necesidades locales mediante talleres participativos, selección de caracteres prioritarios (adaptación local, calidad específica), metodología de selección en finca, empoderamiento de agricultores en toma de decisiones, validación y difusión horizontal entre comunidades.',
      ejemplo:
        'Cultivos apropiados: Variedades criollas de maíz, poroto, zapallo, quinoa.',
    },
    {
      id: 5,
      titulo: 'Proyecto 5: Conservación de Recursos Genéticos',
      descripcion:
        'Plan de conservación in situ o ex situ de variedades criollas/landraces de un cultivo regional. Debe contemplar: relevamiento y caracterización morfológica/molecular de variedades locales, documentación de conocimiento tradicional asociado, estrategias de mantenimiento (conservación in situ en finca, ex situ en banco de germoplasma), regeneración periódica, y plan de uso sostenible en mejoramiento.',
      ejemplo: 'Ejemplos: Maíces criollos del NOA, porotos andinos, zapallos regionales.',
    },
    {
      id: 6,
      titulo: 'Proyecto 6: Mejoramiento para Cambio Climático',
      descripcion:
        'Diseño de estrategia de mejoramiento para adaptación a escenarios climáticos futuros (2030-2050). Incluir: análisis de proyecciones climáticas regionales (temperatura, precipitación, eventos extremos), identificación de caracteres adaptativos críticos (tolerancia a sequía/calor, eficiencia uso agua, plasticidad fenológica), fuentes de variabilidad genética (germoplasma exótico, parientes silvestres), y metodología de selección bajo estrés.',
      ejemplo:
        'Cultivos prioritarios: Trigo (sequía terminal), Maíz (estrés térmico en floración), Soja (períodos secos críticos).',
    },
  ];

  return (
    <div className={styles.resourcesPage}>
      <div className={styles.header}>
        <h2>💼 Proyectos Finales Sugeridos</h2>
        <p className={styles.subtitle}>
          Propuestas de proyectos integradores para aplicar los conocimientos adquiridos en la
          materia. Estos proyectos permiten profundizar en áreas específicas del mejoramiento
          genético y desarrollar habilidades de investigación, análisis crítico y comunicación
          científica.
        </p>
      </div>

      <div className={styles.projectsGrid}>
        {proyectos.map((proyecto) => (
          <div key={proyecto.id} className={styles.projectCard}>
            <h3 className={styles.projectTitle}>{proyecto.titulo}</h3>
            <p className={styles.projectDescription}>{proyecto.descripcion}</p>
            <div className={styles.projectExample}>
              <strong>Ejemplo:</strong> {proyecto.ejemplo}
            </div>
          </div>
        ))}
      </div>

      <div className={styles.requirementsSection}>
        <h3 className={styles.sectionTitle}>📋 Formato y Requisitos de Entrega</h3>
        <div className={styles.requirementsList}>
          <div className={styles.requirementItem}>
            <h4>Extensión</h4>
            <p>15-25 páginas (sin incluir anexos)</p>
          </div>
          <div className={styles.requirementItem}>
            <h4>Estructura Obligatoria</h4>
            <ul className={styles.list}>
              <li>Portada con datos de asignatura, estudiante(s) y fecha</li>
              <li>Índice</li>
              <li>Introducción y justificación</li>
              <li>Objetivo general y objetivos específicos</li>
              <li>Desarrollo (métodos, resultados esperados, cronograma)</li>
              <li>Referencias bibliográficas (mínimo 20 fuentes)</li>
              <li>Anexos (datos, gráficos, diagramas)</li>
            </ul>
          </div>
          <div className={styles.requirementItem}>
            <h4>Formato</h4>
            <p>PDF o DOCX (MS Word), fuente Arial 11 pt, espaciado 1.5 líneas, márgenes 2.5 cm</p>
          </div>
          <div className={styles.requirementItem}>
            <h4>Referencias</h4>
            <p>Formato APA 7ª edición, mínimo 20 referencias de literatura científica</p>
          </div>
          <div className={styles.requirementItem}>
            <h4>Fecha de Entrega</h4>
            <p>Última semana de clases (consultar calendario académico)</p>
          </div>
        </div>
      </div>

      <div className={styles.rubricSection}>
        <h3 className={styles.sectionTitle}>📊 Criterios de Evaluación</h3>
        <div className={styles.rubricTable}>
          <div className={styles.rubricRow}>
            <div className={styles.rubricCell}>Originalidad e innovación</div>
            <div className={styles.rubricCell}>Profundidad de análisis</div>
            <div className={styles.rubricCell}>Viabilidad técnica</div>
            <div className={styles.rubricCell}>Calidad de presentación</div>
          </div>
          <div className={styles.rubricRow}>
            <div className={styles.rubricCell}>20%</div>
            <div className={styles.rubricCell}>30%</div>
            <div className={styles.rubricCell}>30%</div>
            <div className={styles.rubricCell}>20%</div>
          </div>
        </div>
      </div>
    </div>
  );
};
